import { NgModule } from '@angular/core';
import { NgClass } from '@angular/common';
import { TooltipModule } from '@app/modules/ui/tooltip/tooltip.module';
import { IconsStandaloneComponent } from '@app/shared/modules/icons/components/icon-standalone/icon.component';
import { TranslateModule } from '@app/shared/modules/translate/translate.module';
import { ResumeUploaderComponent } from './resume-uploader.component';
import { IcUploadFilesComponent } from '@shared/modules/icons/components/ic/ic-upload-files.component';
import { IcFileDocumentComponent } from '@shared/modules/icons/components/ic/ic-file-document.component';
import { IcAlertCircleComponent } from '@shared/modules/icons/components/ic/ic-alert-circle.component';
import { FilenameShortenerPipe } from './file-name-shortener.pipe';

@NgModule({
  declarations: [ResumeUploaderComponent],
  exports: [ResumeUploaderComponent],
  imports: [
    TooltipModule,
    NgClass,
    IconsStandaloneComponent,
    TranslateModule,
    IcUploadFilesComponent,
    IcFileDocumentComponent,
    IcAlertCircleComponent,
    FilenameShortenerPipe
  ]
})
export class ResumeUploaderModule {}
